import React from 'react';
import { Button } from 'reactstrap';
import injectSheet from 'react-jss';
import { Subscribe } from 'unstated';
import { Link } from 'react-router-dom';
import JamParentSelectContainer from '../containers/JamParentSelectContainer';

const styles = {
  footerWrapper: {
    backgroundColor: '#FFFFFF',
    fontSize: '0.875rem',
    fontFamily: 'Lato, Arial',
    height: '3.5rem',
    borderTop: '1px solid #e8eae9',
    WebkitBoxShadow: '0px 2px 26px -8px rgba(0,0,0,0.47)',
    MozBoxShadow: '0px 2px 26px -8px rgba(0,0,0,0.47)',
    boxShadow: '0px 2px 26px -8px rgba(0,0,0,0.47)',
    paddingTop: '0.5rem',
    paddingRight: '5.25rem',
    paddingLeft: '5.25rem',
    paddingBottom: '0.5rem',
    position: 'fixed',
    width: '100%',
    bottom: '0 !important',
    zIndex: 10,
  },
  backBtn: {
    fontFamily: 'Lato, Arial',
    color: '#979797',
    display: 'inline-block',
    cursor: 'pointer',
    padding: '0.5rem',
    '&:hover': {
      textDecoration: 'none',
      color: '#979797',
    },
  },
  continueBtnWrapper: {
    fontFamily: 'Lato, Arial',
    display: 'inline-block',
    float: 'right',
    marginRight: '1.25rem',
  },
  continueBtn: {
    backgroundColor: '#34A5DA',
    color: '#FFFFFF',
    fontSize: '1rem',
    borderColor: '#34A5DA',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#34A5DA',
      borderColor: '#34A5DA',
      boxShadow: 'none',
    },
    '&:active': {
      backgroundColor: '#34A5DA !important',
      borderColor: '#34A5DA !important',
      boxShadow: 'none',
    },
    '&> a': {
      color: '#FFFFFF',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  draftBtn: {
    marginRight: '1rem',
    fontFamily: 'Lato, Arial',
    color: '#34A5DA',
    display: 'inline-block',
    cursor: 'pointer',
    padding: '0.5rem',
    '&:hover': {
      textDecoration: 'none',
      color: '#34A5DA',
    },
  },
};

const Footer = (props) => {
  const { classes, backBtnLabel, back, to, draft, draftTo, actionBtnLabel, onNext, onPrev, onSave } = props;
  return (
    <Subscribe to={[JamParentSelectContainer]}>
      { jamParent => (
        <div className={classes.footerWrapper}>
          <span>
            {backBtnLabel ? <Link onClick={onPrev} className={classes.backBtn} to={back}>{backBtnLabel}</Link> : ''}
          </span>
          <span className={classes.continueBtnWrapper}>
            {draft ? <Link onClick={onSave} className={classes.draftBtn} to={draftTo}>{draft}</Link> : ''}
            <Link onClick={onNext} to={to}><Button className={classes.continueBtn}>{actionBtnLabel}</Button></Link>
          </span>
        </div>
      )}
    </Subscribe>
  );
};

export default injectSheet(styles)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js